var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiamond(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 40.5c15.568 0 36-23.701 36-36.5 0 12.799 20.432 36.5 36 36.5-15.568 0-36 23.701-36 36.5 0-12.799-20.432-36.5-36-36.5z",
    stroke: "#000",
    strokeWidth: 5,
    strokeLinejoin: "round"
  })));
}
export default SvgDiamond;